// Simple/Clean version for sidebar - without Alert button and footer
"use client";

import { Segmant, Title } from "../../../components";
import { SaleHomeList } from "../../../common/index.js";

export default function SaleHomesSectionSimple({
  isMobile,
  homes,
  heart,
  onSaveHeart,
  togglePrev,
  activePage2,
  checkIfImageExists,
}) {
  return (
    <>
      <div className="sale_listing_title">
        <Title
          name="Homes for Sale in this Neighborhood"
          size="medium"
          colorClass="black"
          as="h2"
        />
      </div>

      <Segmant basic className="lisitng_segment" style={{ padding: 0 }}>
        <SaleHomeList
          id="sale"
          save={onSaveHeart}
          heart={heart}
          cardData={homes || []}
          href="/DetailsListing"
          prev={togglePrev}
          active={activePage2}
          checkIfImageExistshome={(e) => checkIfImageExists(e)}
          isMobile={isMobile}
          pageSize={1}
        />
      </Segmant>
    </>
  );
}
